// @flow

import { Alert, Text } from 'reshaped';

import { useTranslator } from '@gandi/translate';

export function EditingAlert(): React.MixedElement {
  const { __ } = useTranslator();

  return (
    <Alert color="warning">
      <Text variant="caption-1">
        {__(
          'Changes made in this form are only applied to current and future orders; your previous purchases will not be modified.',
        )}
      </Text>
    </Alert>
  );
}
